// @flow
import React, { useContext } from 'react';
import classnames from 'classnames';
import { PriceRemoteContext } from 'Components/widgets/price-remote/PriceRemoteContext';

import { t } from 'Src/i18n';
import { ICONS } from 'Components/utils/icon/icons';
import { COLORS } from 'Components/utils/color/colors';

import { Icon } from 'Components/frameworks/icon/Icon';
import { StripButton } from 'Components/frameworks/strip-button/StripButton';

type Props = {
  handleClick: () => mixed,
  isCollapsed: boolean,
  isDesktop: boolean,
  isSticky?: boolean,
};

export const PriceRemoteTitleButton = ({
  handleClick,
  isCollapsed,
  isDesktop,
  isSticky = false,
}: Props) => {
  const [{ isJoyview }] = useContext(PriceRemoteContext);
  const buttonLabel = isCollapsed
    ? t('priceRemote.closeAllInclusiveDetails')
    : t('priceRemote.openAllInclusiveDetails');
  const color = isJoyview ? COLORS.WATER_GREEN : COLORS.BLUE;

  return isSticky && !isDesktop ? (
    <button
      className={`bg-transparent text-center text-${color} underline text-base font-bold pt-1 pb-2`}
      onClick={handleClick}
      type="button"
    >
      {buttonLabel}
      <Icon
        className={classnames('text-blue rtl:ml-2 transition-transform', {
          ['rotate-180']: isCollapsed,
        })}
        name={ICONS.BOLDER_ARROW_FORTH}
        width="0.625rem"
      />
    </button>
  ) : (
    <StripButton
      className={`font-bold text-center text-${color} text-sm underline`}
      height={30}
      onClick={handleClick}
      orientation={isSticky && isDesktop ? 'top' : 'bottom'}
    >
      <div className="flex items-center text-base">
        {buttonLabel}
        <div
          className={classnames('rtl:ml-2', {
            ['rotate-180']: isSticky && isDesktop,
          })}
        >
          <Icon
            className={classnames('text-blue transition-transform', {
              ['rotate-180']: isCollapsed,
            })}
            name={ICONS.BOLDER_ARROW_FORTH_DOWN}
            width="0.625rem"
          />
        </div>
      </div>
    </StripButton>
  );
};
